import React from "react";
import { CSelect, CFormGroup, CLabel, CCol } from "@coreui/react";
import { Controller } from "react-hook-form";

import ErrorInput from "../ErrorInput";

function CustomSelect({
  options,
  placeholder,
  name,
  control,
  required,
  errors,
  bold,
  defaultValue = "",
  onSelect,
}) {
  const invalid = (errors, name) => (errors[name] ? true : false);
  return (
    <CFormGroup row>
      <CCol md="4">
        <CLabel htmlFor="ccmonth">
          {bold ? (
            <b>{`${placeholder}${required ? "*" : ""}`}</b>
          ) : (
            `${placeholder}${required ? "*" : ""}`
          )}
        </CLabel>
      </CCol>
      <CCol xs="12" md="8">
        <Controller
          rules={{ required }}
          control={control}
          name={name}
          render={(props) => (
            <CSelect
              custom
              defaultValue={defaultValue}
              onChange={(e) => {
                props.onChange(e.target.value);
                onSelect && onSelect(e.target.value);
              }}
            >
              {options &&
                options.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
            </CSelect>
          )}
          options={options}
          defaultValue={defaultValue}
          custom
        />
        {invalid(errors, name) && (
          <ErrorInput text={`${placeholder} es obligatorio`} />
        )}
      </CCol>
    </CFormGroup>
  );
}

export default CustomSelect;
